// Password strength utility

export function getPasswordStrength(password) {
  let score = 0;
  if (password.length >= 8) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) score++;

  // Very easy/weak: 0-1, Easy/weak: 2, Fair: 3, Strong: 4, Very Strong: 5
  let level = "Very Weak";
  let color = "#dc3545";
  let percentage = 20;
  if (score === 1) {
    level = "Weak";
    color = "#ff7675";
    percentage = 30;
  } else if (score === 2) {
    level = "Easy";
    color = "#fdcb6e";
    percentage = 45;
  } else if (score === 3) {
    level = "Fair";
    color = "#0984e3";
    percentage = 60;
  } else if (score === 4) {
    level = "Strong";
    color = "#5be6b9"; // lighter green shade
    percentage = 80;
  } else if (score === 5) {
    level = "Very Strong";
    color = "#00b894";
    percentage = 100;
  }
  return { level, color, percentage };
}
